import { HttpError } from "@klw/fetch/lib/types";
import { assign, createMachine } from "xstate";
import { z } from "zod";
import { PlaylistRuleRestriction } from "../../../types";

export type Context = {
  error?: string;
  restriction: Partial<PlaylistRuleRestriction>;
};

export type Event =
  | { type: "OPEN" }
  | { type: "CLOSE" }
  | { type: "CHANGE"; restriction: Partial<PlaylistRuleRestriction> }
  | { type: "SUBMIT" };

export type Services = {
  addPlaylistRestriction: { data: HttpError | void };
};

export const addPlaylistRestrictionMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QEMIQAoBtkE9MEtYAXAWWQGMALfAOzADoBJAEQBkBRAYgHl12A5ANoAGALqJQABwD2sfEXzSaEkAA9EAVgBMAGhA5EADgCM9ACyGNANgDsGk8Zu37AXxd7UGbHkKkK1OnoSbmYAQVYAfV4BJjYuAGUAVQAhEkYAFRFxJBAZOQUlFXUELWMtehsbAE4zDQ0zGwBmW0c9AwRGp3oq4zMreptDKq1hV3cQTyxcAmIyKloGYLDI6P5Yjk4AYQAJUP4AcXYslTz5RWUc4sMbNsQtG1MtYcNaq2MqntsrNw80KZ9Zv4FkEQuEonw1iwNptWNx4kcxCdZGdCpdEP1hPRhFZnoZGmZjBpOlVbggzFVDPQtM1etdLPYbGZGj8Jn9vDM-PNAkswat6OgAErcTbseLxRgHTgQJQMWgAN2kAGsGJN2b45gFFqCVhD+UKRWKJfsEPLpORkAUaFljjlTpaiuiNJjsbj8YTiaSnjYKlo+hpCRZGhonCzVdN1UDudrwTFBcLReLJWAAE7J6TJ+iSbBEABm6YAtvQwwDOZqQcsY2s4wbE8bTebLdbEbbkfa0SVGqYHvYmWYzE9rC9PSZ6I0XsIhrV-W9jG5xjRpBA4CpixyNQskflzg6EABaEn6RC777jVcRrkMKHsTcoi6gK6NTEfYZWTuGa6NfGkxpacpWKwvGYwilEMFJmKGbLhoCF7lryEI3m296II0B7tMYeL0IYwgPDiWEmOS6EQV4UGlsCPI6jEV4Idu7bGKM9AaFUlRjq+LzGJ+uiHh0jLdL0-QNEMIxjL8xEluuUYVny1YJka1GokhZLGI8DzvNcWjBs0nHtAO3QAb61RBtUwjgXOQA */
  createMachine(
    {
      id: "addPlaylistRestrictionMachine",
      schema: {
        context: {} as Context,
        events: {} as Event,
        services: {} as Services,
      },
      tsTypes: {} as import("./addPlaylistRestrictionMachine.typegen").Typegen0,
      initial: "IDLE",
      states: {
        IDLE: {
          on: {
            OPEN: {
              target: "MODAL_OPEN",
            },
          },
        },
        MODAL_OPEN: {
          initial: "IDLE",
          states: {
            IDLE: {
              on: {
                SUBMIT: {
                  target: "PROCESSING",
                  cond: "isValid",
                },
                CHANGE: {
                  actions: "change",
                },
                CLOSE: {
                  target: "#addPlaylistRestrictionMachine.IDLE",
                  actions: "reset",
                },
              },
            },
            PROCESSING: {
              invoke: {
                src: "addPlaylistRestriction",
                onDone: [
                  {
                    target: "#addPlaylistRestrictionMachine.IDLE",
                    actions: "reset",
                  },
                ],
                onError: [
                  {
                    target: "IDLE",
                    actions: "assignError",
                  },
                ],
              },
            },
          },
        },
      },
    },
    {
      actions: {
        change: assign((_, event) => ({
          restriction: event.restriction,
        })),
        reset: assign({ restriction: {}, error: undefined }),
        assignError: assign((_, __) => ({
          error: "playlist.settings.rules.addError",
        })),
      },
      guards: {
        isValid: (context, _) => {
          const schema = z.object({
            restriction: z.object({
              metaDatumKey: z.string().min(1),
              limit: z.number().min(1),
              factor: z.number().min(1),
              unit: z.string().min(1),
            }),
          });
          
          const result = schema.safeParse(context);
          return result.success;
        },
      },
    }
  );
